// Scripts librairies
// import { docReady } from './js/libs/utils'

// Global styles
import './scss/custom_light'

// Scripts librairies
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks'

// Charge la base commune
require('./common.js')

// étend lazysize pour charger des scripts à la volée
window.lazySizesConfig = window.lazySizesConfig || {}
window.lazySizesConfig.requireJs = function (modules, cb) {
  window.require(modules, cb)
}
